// extracted by mini-css-extract-plugin
export default {"relative":"NavigationItems_relative__9NlTS","navigationList":"NavigationItems_navigationList__IrzeC"};